package com.fantasytenis.shared.domain.auth.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.core.utils.SharedPrefs
import com.fantasytenis.shared.data.auth.repository.AuthRepository
import com.fantasytenis.shared.domain.auth.entity.UserEntity

/**
 * Register Use Case.
 *
 * Handles new user registration.
 */
class RegisterUseCase(
    private val authRepository: AuthRepository,
    private val sharedPrefs: SharedPrefs
) {
    /**
     * Execute registration with user details.
     *
     * @param email User's email
     * @param password User's password
     * @param firstName User's first name
     * @param lastName User's last name
     * @param username User's unique username
     * @return Result containing UserEntity on success
     */
    suspend operator fun invoke(
        email: String,
        password: String,
        firstName: String,
        lastName: String,
        username: String
    ): Result<UserEntity> {
        return authRepository.register(email, password, firstName, lastName, username)
            .onSuccess { authData ->
                // Store tokens
                sharedPrefs.setAccessToken(authData.accessToken)
                sharedPrefs.setRefreshToken(authData.refreshToken)
                sharedPrefs.setUserId(authData.user.id)

                // Update global state
                SharedData.accessToken.value = authData.accessToken
                SharedData.currentUser.value = authData.user
                SharedData.loggedIn.value = true
            }
            .map { it.user }
    }
}
